export const translations = {
  fr: {
    // Common
    appName: "Servitech Xpert",
    portalName: "Portail Clients",
    logout: "Déconnexion",
    search: "Rechercher",
    loading: "Chargement...",
    back: "Retour",
    noResults: "Aucun résultat",
    vsLastYear: "vs année précédente",
    currency: "$",
    shopTagline: "Boutique en ligne",
    catalog: "Catalogue",
    website: "Site Web",
    websiteSection: "Bannière d'accueil",
    websiteDesc: "Gérez les images du carrousel de la page d'accueil (français et anglais).",
    bannersFr: "Bannières (Français)",
    bannersEn: "Bannières (Anglais)",
    addImageUrl: "Ajouter par URL",
    uploadImage: "Téléverser une image",
    uploadPdf: "Téléverser un PDF",
    imageUrlPh: "https://…jpg",
    noBanners: "Aucune bannière — ajoutez-en une.",
    uploading: "Téléversement…",
    banners: "Bannières",
    addBanner: "Ajouter une bannière",
    bannerName: "Nom",
    bannerType: "Type",
    graphicBanner: "Bannière graphique",
    creationDate: "Date de création",
    status: "Statut",
    active: "Actif",
    disabled: "Désactivé",
    imageFr: "Image (Français)",
    imageEn: "Image (Anglais)",
    linkUrl: "URL de destination",
    openNewWindow: "Ouvrir dans une nouvelle fenêtre",
    displayOrder: "Ordre d'affichage",
    editBanner: "Modifier la bannière",
    newBanner: "Nouvelle bannière",
    orUrl: "ou coller une URL",
    deleteBanner: "Supprimer",
    confirmDeleteBanner: "Supprimer cette bannière ?",
    preview: "Aperçu",
    blog: "Blog",
    layout: "Disposition",
    settings: "Réglages",
    coopMode: "Mode COOP",
    coopModeDesc: "Choisissez où les factures sont envoyées à la COOP.",
    coopModeProduction: "Production (vraies factures)",
    coopModeTest: "Test (sandbox)",
    coopModeProdWarning: "Mode Production actif : les factures envoyées à la COOP sont RÉELLES.",
    coopModeTestInfo: "Mode Test actif : aucune vraie facture n'est créée à la COOP.",
    comingSoon: "Bientôt disponible",
    comingSoonDesc: "Cette section sera bientôt disponible.",
    general: "Général",
    similarProducts: "Produits similaires",
    variations: "Variations",
    searchProduct: "Rechercher un produit…",
    addVariant: "Ajouter",
    variationGroup: "Groupe de variation",
    variationLabelField: "Étiquette de variation",
    noVariants: "Aucune variante. Ajoutez-en une ci-dessous.",
    noSimilar: "Aucun produit similaire sélectionné.",
    formatCol: "Format",
    location: "Emplacement",
    locCarousel: "Carrousel principal",
    locLeft: "Bannière centrale gauche",
    locRight: "Bannière centrale droite",
    layoutSections: "Sections d'accueil",
    titleFr: "Titre (Français)",
    titleEn: "Titre (Anglais)",
    fillMode: "Mode de remplissage",
    modeManual: "Manuel",
    modeNewest: "Les plus récents",
    modeRandom: "Aléatoire",
    limitField: "Limite (max 12)",
    searchProducts: "Rechercher par code produit ou nom...",
    allCategories: "Toutes les catégories",
    addToCart: "Ajouter",
    addedToCart: "Ajouté au panier",
    cart: "Panier",
    emptyCart: "Votre panier est vide",
    continueShopping: "Continuer les achats",
    backToShop: "Retour à la boutique",
    noProducts: "Aucun produit trouvé",
    datasheets: "Fiches techniques (PDF)",
    priceHidden: "Les prix ne sont pas affichés. Passez votre commande et un représentant vous confirmera les prix.",
    orderInfo: "Vos coordonnées",
    contactName: "Nom du contact",
    note: "Note (optionnel)",
    placeOrder: "Passer la commande",
    orderPlaced: "Commande envoyée avec succès !",
    orderFailed: "Échec de l'envoi de la commande",
    adminLogin: "Connexion admin",
    myAccount: "Mon compte",
    register: "S'inscrire",
    navigation: "Navigation",
    home: "Accueil",
    contact: "Contact",
    allProducts: "Tous les produits",
    moreCategories: "Plus de catégories",
    footerAbout: "Produits et équipements sanitaires pour les professionnels.",
    rightsReserved: "Tous droits réservés.",
    aboutTitle: "À propos de nous",
    aboutIntro: "Servitech Xpert est une jeune entreprise en pleine expansion, fondée en 2007 par Daniel Valiquette, qui possède plus de 20 ans d'expérience dans le domaine. Servitech Xpert distribue une gamme complète de produits et d'équipements sanitaires à ses clients, en plus d'offrir un service de réparation exceptionnel. Nous sommes en mesure de vous offrir une solution clé en main adaptée à vos besoins.",
    aboutPartnersTitle: "Partenariat avec nos fournisseurs",
    aboutPartnersText: "Vous pouvez compter sur Servitech Xpert pour trouver les meilleurs fournisseurs dans leur catégorie — des fournisseurs qui ont bâti leur réputation en développant des produits efficaces et fiables. Ces fournisseurs nous aident à offrir des solutions pour optimiser l'efficacité de vos opérations.",
    aboutBrandsTitle: "Nos marques",
    contactHeroTitle: "Contactez-nous",
    contactInfoTitle: "Coordonnées",
    contactFormTitle: "Formulaire de contact",
    contactFormIntro: "Pour communiquer avec nous ou pour toute autre demande d'information, écrivez-nous ici. Nous vous répondrons dans les plus brefs délais.",
    ciAddress: "Adresse",
    ciEmail: "Courriel",
    ciPhone: "Téléphone",
    ciTollFree: "Sans frais",
    ciFax: "Télécopieur",
    fldName: "Nom complet",
    fldSubject: "Sujet",
    fldMessage: "Message",
    fldSend: "Envoyer",
    contactSent: "Merci ! Votre message a été envoyé. Nous vous répondrons bientôt.",
    contactErr: "Échec de l'envoi. Veuillez réessayer.",
    newProducts: "Nouveaux produits",
    featuredProducts: "Produits vedettes",
    brands: "Marques",
    brandsManagerHint: "Gérez les logos de marques affichés en bas du site (accueil et À propos). Le nom sert uniquement à les identifier ici.",
    addBrand: "Ajouter une marque",
    noBrands: "Aucune marque. Cliquez sur « Ajouter une marque ».",
    brandName: "Nom de la marque (identification)",
    addLogo: "Ajouter le logo",
    replaceLogo: "Remplacer le logo",
    logoUpdated: "Logo mis à jour",
    uploadFailed: "Échec du téléversement",
    saveFailed: "Échec de l'enregistrement",
    visible: "Visible",
    hidden: "Masqué",
    viewCategoryProducts: "Voir les produits de cette catégorie",
    openProductPage: "Ouvrir la fiche du produit (nouvel onglet)",
    filteredByCategory: "Filtré par catégorie",
    clearFilter: "Effacer le filtre",
    shopNow: "Magasiner",
    heroTitle: "Produits et équipements sanitaires",
    heroText: "Passez vos commandes en ligne — un représentant confirmera les prix.",
    myCart: "Mon panier",
    cartEmpty: "Panier vide",
    items: "articles",
    aboutCompany: "À propos",
    blog: "Blogue",
    paperSystemTitle: "Systèmes de produits de papier",
    handSystemTitle: "Systèmes de soin des mains",
    viewCategory: "Voir la catégorie",
    blogHeroTitle: "Dernières nouvelles",
    blogEmpty: "Aucun article pour le moment. Revenez bientôt !",
    blogReadMore: "Lire la suite",
    blogBackToList: "Retour aux actualités",
    blogPublishedOn: "Publié le",
    addArticle: "Ajouter un article",
    newArticle: "Nouvel article",
    editArticle: "Modifier l'article",
    deleteArticle: "Supprimer",
    confirmDeleteArticle: "Supprimer cet article ?",
    noArticles: "Aucun article. Cliquez sur « Ajouter un article » pour commencer.",
    articleTitleFr: "Titre (FR)",
    articleTitleEn: "Titre (EN)",
    articleExcerptFr: "Extrait (FR)",
    articleExcerptEn: "Extrait (EN)",
    articleBodyFr: "Contenu (FR)",
    articleBodyEn: "Contenu (EN)",
    articleCover: "Image de couverture",
    articleSlug: "Identifiant URL (slug)",
    articleStatus: "Statut",
    statusDraft: "Brouillon",
    statusPublished: "Publié",
    // Login
    loginTitle: "Portail interne",
    loginSubtitle: "Suivi des ventes et de la consommation client",
    email: "Courriel",
    email2: "Courriel 2",
    noteInterne: "Note interne",
    noteClient: "Note client",
    noteInterneHint: "Usage interne — jamais visible du client",
    noteClientHint: "Visible du client (imprimée sur la facture)",
    poNumber: "Bon de commande",
    poNumberHint: "N° de bon de commande (optionnel)",
    withSimilar: "Ajouter avec produits similaires du site",
    password: "Mot de passe",
    signIn: "Se connecter",
    signingIn: "Connexion...",
    loginError: "Courriel ou mot de passe invalide",
    confidential: "Usage interne strictement confidentiel",
    // Dashboard
    dashboard: "Tableau de bord",
    customers: "Clients",
    totalCustomers: "Clients actifs",
    totalSalesYtd: "Ventes cumulées (année courante)",
    growingCustomers: "Clients en croissance",
    decliningCustomers: "Clients en déclin",
    topCustomers: "Principaux clients",
    searchCustomers: "Rechercher un client, # de compte, code COOP, contact...",
    // Sync
    dataSource: "Source des données",
    demoData: "Données de démonstration",
    liveData: "CS-Cart en direct",
    syncNow: "Synchroniser CS-Cart",
    syncing: "Synchronisation...",
    lastSync: "Dernière synchro",
    neverSynced: "Jamais synchronisé",
    syncStarted: "Synchronisation démarrée...",
    syncDone: "Données CS-Cart synchronisées",
    syncFailed: "Échec de la synchronisation",
    // Customer table
    businessName: "Nom du client",
    accountNumber: "# de compte",
    contact: "Contact",
    coopClientCode: "Code client COOP",
    phone: "Téléphone",
    salesYtd: "Ventes (année)",
    trend: "Tendance",
    products: "Produits",
    viewProfile: "Voir le dossier",
    // Customer detail
    customerProfile: "Dossier client",
    address: "Adresse",
    fax: "Télécopieur",
    faxNotAvailable: "Non disponible",
    generalContact: "Contact général",
    currentMonthSales: "Ventes du mois courant",
    ytdSales: "Ventes cumulées (année)",
    samePeriodLastYear: "Même période l'an dernier",
    monthlyConsumption: "Consommation mensuelle (12 derniers mois)",
    salesComparison: "Comparaison des ventes",
    noSalesRecorded: "Aucune vente enregistrée pour ce client (aucune commande)",
    productDetails: "Détails des produits",
    productCode: "Code produit",
    description: "Description",
    lastPaidPrice: "Dernier prix payé",
    lastPaidDate: "Date",
    qtyThisYear: "Qté année courante",
    qtyLastYear: "Qté année précédente",
    currentYear: "Année courante",
    previousYear: "Année précédente",
    generateReport: "Générer le rapport",
    annualReport: "Rapport annuel",
    monthlyBreakdown: "Détail mensuel",
    month: "Mois",
    total: "Total",
    year: "Année",
    print: "Imprimer",
    backOffice: "Back Office",
    ordersManagement: "Gestion des commandes",
    searchOrders: "Rechercher",
    searchOrdersHint: "N° de facture, client ou code COOP",
    dateFrom: "Du",
    dateTo: "Au",
    allStatuses: "Tous les statuts",
    clearFilters: "Effacer",
    resultSingular: "commande",
    resultPlural: "commandes",
    noOrdersMatch: "Aucune commande ne correspond aux filtres",
    orders: "Commandes",
    orderFrom: "Client",
    placedOn: "Date",
    orderDetail: "Détail de la commande",
    orderItems: "Articles",
    status: "Statut",
    statusNew: "Nouvelle",
    statusPriced: "Prix ajoutés",
    statusInvoiced: "Facturée",
    statusSent: "Envoyée",
    unitPrice: "Prix unitaire",
    quantity: "Qté",
    grandTotal: "Total",
    subtotal: "Sous-total",
    gstShort: "TPS (5%)",
    qstShort: "TVQ (9,975%)",
    savePricing: "Enregistrer les prix",
    generateInvoice: "Générer la facture",
    editInvoice: "Modifier la facture",
    deleteInvoice: "Supprimer",
    confirmDeleteInvoice: "Supprimer cette facture / commande ? Cette action est irréversible.",
    invoiceFrozen: "Facture figée (payée ou envoyée COOP)",
    deleted: "Supprimé",
    downloadPdf: "Télécharger le PDF",
    sendInvoice: "Envoyer par courriel",
    invoiceSent: "Facture envoyée",
    invoiceCreated: "Facture générée",
    invoiceNumber: "N° de facture",
    priceUpdated: "Prix enregistrés",
    saveFailed: "Échec de l'enregistrement",
    pending: "En attente",
    productsManagement: "Gestion des produits",
    editProduct: "Modifier le produit",
    save: "Enregistrer",
    saved: "Enregistré",
    nameFr: "Nom (FR)",
    nameEn: "Nom (EN)",
    descriptionFr: "Description (FR)",
    descriptionEn: "Description (EN)",
    taxGst: "Taxable TPS",
    taxQst: "Taxable TVQ",
    statusActive: "Actif",
    statusDisabled: "Désactivé",
    clientPortal: "Portail client",
    myOrders: "Mes commandes",
    viewInvoice: "Voir la facture",
    backToSite: "Retour au site",
    welcome: "Bienvenue",
    createClientAccount: "Créer un compte client",
    createAccount: "Créer un compte",
    clientRegisterInfo: "Utilisez le courriel associé à votre compte client Servitech Xpert.",
    registerError: "Impossible de créer le compte",
    price: "Prix",
    category: "Catégorie",
    actions: "Actions",
    edit: "Modifier",
    pdf: "PDF",
    name: "Nom",
    images: "Images",
    imageUrl: "URL de l'image",
    addPdf: "Ajouter un PDF",
    statusHidden: "Caché",
    productUpdated: "Produit mis à jour avec succès",
    deleteProduct: "Supprimer le produit",
    deleteProductTitle: "Supprimer définitivement ce produit ?",
    deleteProductWarning: "Cette action est irréversible. Le produit et ses variantes seront supprimés définitivement de la base de données.",
    deletePermanently: "Supprimer définitivement",
    productDeleted: "Produit supprimé",
    customerDeleted: "Client supprimé",
    deleteCustomerTitle: "Supprimer ce client ?",
    deleteCustomerWarning: "Cette action est définitive. La fiche client et son compte d'accès seront supprimés. L'historique des commandes/factures est conservé. Les autres succursales ne sont pas touchées.",
    deleteFailed: "Échec de la suppression",
    newVariation: "Nouvelle variation",
    addVariationBtn: "Ajouter la variation",
    attachExisting: "Ou rattacher un produit existant",
    newVariationHint: "Crée une nouvelle variation de ce produit (nom, image et catégorie repris du produit parent, modifiables dans la ligne).",
    variantCreated: "Variation créée",
    pdfUploadedClickSave: "PDF téléversé — cliquez sur « Enregistrer » pour l'ajouter au produit",
    pdfNameFr: "Nom affiché (FR)",
    pdfNameEn: "Nom affiché (EN)",
    variationDeleted: "Variation supprimée",
    deleteVariationTitle: "Supprimer cette variation ?",
    deleteVariationWarning: "Cette variation sera supprimée définitivement. Les autres variations du produit ne sont pas affectées.",
    deleteCategory: "Supprimer la catégorie",
    deleteCategoryTitle: "Supprimer définitivement cette catégorie ?",
    deleteCategoryWarning: "La catégorie sera supprimée. Les produits ne sont PAS supprimés, ils perdent seulement ce classement.",
    subcategoriesAlsoDeleted: "sous-catégorie(s) seront aussi supprimées",
    categoryDeleted: "Catégorie supprimée",
    saveAndClose: "Enregistrer et fermer",
    cancel: "Annuler",
    stock: "Inventaire",
    editingLanguage: "Langue d'édition",
    searchCategory: "Rechercher une catégorie...",
    customerInformation: "Informations client",
    billingAddress: "Adresse de facturation",
    shippingSameAsBilling: "Adresse de livraison identique à la facturation",
    savedShipAddresses: "Adresses de livraison enregistrées",
    savedShipAddressesHint: "Ajoutez plusieurs adresses de livraison nommées. Elles seront proposées dans un menu lors de la création d'une commande.",
    addShipAddress: "Ajouter une adresse",
    noShipAddresses: "Aucune adresse de livraison enregistrée.",
    shipAddressName: "Nom de l'adresse",
    shipAddressNamePlaceholder: "ex. Entrepôt principal, Magasin Laval",
    chooseShipAddress: "Choisir l'adresse de livraison",
    useBillingAddress: "Adresse de facturation",
    otherManualAddress: "Autre — saisir manuellement",
    remove: "Retirer",
    orderSummary: "Résumé de la commande",
    inStock: "en stock",
    categories: "Catégories",
    manageCategories: "Gestion des catégories",
    position: "Pos.",
    activeCategories: "Catégories actives",
    hiddenCategories: "Catégories cachées",
    disabledCategories: "Catégories désactivées",
    totalProducts: "Produits",
    addCategory: "Ajouter une catégorie",
    addSubcategory: "Sous-catégorie",
    categorySaved: "Catégorie enregistrée",
    noCategories: "Aucune catégorie",
    newCategoryName: "Nom de la nouvelle catégorie",
    catalogTotals: "Total",
    chooseFormat: "Choix de formats",
    newProduct: "Nouveau produit",
    createProduct: "Créer le produit",
    entreprise: "Entreprise",
    succursale: "Succursale",
    selectSuccursale: "Choisir la succursale",
    myBranches: "Mes succursales",
    branch: "Succursale",
    newOrder: "Nouvelle commande",
    createOrder: "Créer la commande",
    orderCreated: "Commande créée",
    searchClient: "Rechercher un client...",
    searchProduct: "Rechercher un produit...",
    addProduct: "Ajouter un produit",
    client: "Client",
    noItems: "Aucun produit",
    sendCoop: "Envoyer COOP",
    coopSent: "Envoyée à COOP",
    coopAlreadySent: "Déjà envoyée à la COOP le",
    shippingAddress: "Adresse de livraison",
    shipCity: "Ville",
    shipProvince: "Province",
    shipPostal: "Code postal",
    coopCategory: "Catégorie COOP",
    statusCoopSent: "Envoyée COOP",
    statusOpen: "Ouverte",
    statusPaid: "Payée",
    statusComplete: "Complétée",
    statusCancel: "Annulée",
    duplicate: "Dupliquer",
    newCustomer: "Nouveau client",
    createCustomer: "Créer le client",
    firstName: "Prénom",
    lastName: "Nom",
    country: "Pays",
    changeClient: "Changer le client",
    createClientPrompt: "Client introuvable ? Créer un nouveau client",
    send: "Envoyer",
    importAddresses: "Importer adresses",
    of: "sur",
    perPage: "par page",
    note: "Note",
    clients: "Clients",
    viewReport: "Voir le rapport",
    editCustomer: "Modifier le client",
    changePassword: "Mot de passe du portail",
    newPassword: "Nouveau mot de passe",
    setPassword: "Définir le mot de passe",
    passwordUpdated: "Mot de passe mis à jour",
    portalAccount: "Compte portail",
    hasAccount: "Actif",
    noPortalAccount: "Aucun compte",
    passwordHint: "Min. 6 caractères. Le client se connectera avec son courriel.",
    team: "Équipe",
    teamMembers: "Membres de l'équipe",
    myProfile: "Mon profil",
    addMember: "Ajouter un membre",
    newMember: "Nouveau membre",
    role: "Rôle",
    roleAdmin: "Administrateur",
    roleSalesRep: "Vendeur",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    activate: "Activer",
    deactivate: "Désactiver",
    resetPassword: "Réinitialiser le mot de passe",
    currentPassword: "Mot de passe actuel",
    initialPassword: "Mot de passe initial",
    deleteMember: "Supprimer",
    confirmDeleteMember: "Supprimer ce membre ? Cette action est irréversible.",
    memberAdded: "Membre ajouté",
    memberUpdated: "Membre mis à jour",
    memberDeleted: "Membre supprimé",
    profileUpdated: "Profil mis à jour",
    updatePassword: "Modifier le mot de passe",
    salesRepLimits: "Accès : Tableau de bord, Clients, Commandes. Pas de Produits, Catégories, Site web ni Équipe.",
    you: "Vous",
    profileInfo: "Informations du profil",
    changeImage: "Changer l'image",
    requireSignature: "Demander la signature du client",
    requireSignatureHint: "La commande restera « en attente de signature » jusqu'à ce que le client signe.",
    clientSignature: "Signature du client",
    signerName: "Nom du signataire",
    signHere: "Signez ci-dessous",
    clear: "Effacer",
    later: "Plus tard",
    saveSignature: "Enregistrer la signature",
    signatureSaved: "Signature enregistrée",
    awaitingSignature: "En attente de signature",
    collectSignature: "Faire signer",
    signedBy: "Signé par",
    reSign: "Signer à nouveau",
    months: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"],
    monthsFull: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  },
  en: {
    appName: "Servitech Xpert",
    portalName: "Customer Portal",
    logout: "Log out",
    search: "Search",
    loading: "Loading...",
    back: "Back",
    noResults: "No results",
    vsLastYear: "vs previous year",
    currency: "$",
    shopTagline: "Online store",
    catalog: "Catalog",
    website: "Website",
    websiteSection: "Home Banner",
    websiteDesc: "Manage the homepage carousel images (French and English).",
    bannersFr: "Banners (French)",
    bannersEn: "Banners (English)",
    addImageUrl: "Add by URL",
    uploadImage: "Upload image",
    uploadPdf: "Upload a PDF",
    imageUrlPh: "https://…jpg",
    noBanners: "No banner — add one.",
    uploading: "Uploading…",
    banners: "Banners",
    addBanner: "Add banner",
    bannerName: "Name",
    bannerType: "Type",
    graphicBanner: "Graphic banner",
    creationDate: "Creation date",
    status: "Status",
    active: "Active",
    disabled: "Disabled",
    imageFr: "Image (French)",
    imageEn: "Image (English)",
    linkUrl: "Destination URL",
    openNewWindow: "Open in new window",
    displayOrder: "Display order",
    editBanner: "Edit banner",
    newBanner: "New banner",
    orUrl: "or paste a URL",
    deleteBanner: "Delete",
    confirmDeleteBanner: "Delete this banner?",
    preview: "Preview",
    blog: "Blog",
    layout: "Layout",
    settings: "Settings",
    coopMode: "COOP Mode",
    coopModeDesc: "Choose where invoices are sent to COOP.",
    coopModeProduction: "Production (real invoices)",
    coopModeTest: "Test (sandbox)",
    coopModeProdWarning: "Production mode active: invoices sent to COOP are REAL.",
    coopModeTestInfo: "Test mode active: no real invoice is created at COOP.",
    comingSoon: "Coming soon",
    comingSoonDesc: "This section will be available soon.",
    general: "General",
    similarProducts: "Similar products",
    variations: "Variations",
    searchProduct: "Search a product…",
    addVariant: "Add",
    variationGroup: "Variation group",
    variationLabelField: "Variation label",
    noVariants: "No variant. Add one below.",
    noSimilar: "No similar product selected.",
    formatCol: "Format",
    location: "Location",
    locCarousel: "Main carousel",
    locLeft: "Middle banner left",
    locRight: "Middle banner right",
    layoutSections: "Home sections",
    titleFr: "Title (French)",
    titleEn: "Title (English)",
    fillMode: "Filling mode",
    modeManual: "Manually",
    modeNewest: "Newest",
    modeRandom: "Random",
    limitField: "Limit (max 12)",
    searchProducts: "Search by product code or name...",
    allCategories: "All categories",
    addToCart: "Add",
    addedToCart: "Added to cart",
    cart: "Cart",
    emptyCart: "Your cart is empty",
    continueShopping: "Continue shopping",
    backToShop: "Back to shop",
    noProducts: "No products found",
    datasheets: "Datasheets (PDF)",
    priceHidden: "Prices are not shown. Place your order and a representative will confirm pricing.",
    orderInfo: "Your details",
    contactName: "Contact name",
    note: "Note (optional)",
    placeOrder: "Place order",
    orderPlaced: "Order sent successfully!",
    orderFailed: "Failed to send order",
    adminLogin: "Admin login",
    myAccount: "My account",
    register: "Register",
    navigation: "Navigation",
    home: "Home",
    contact: "Contact",
    allProducts: "All products",
    moreCategories: "More categories",
    footerAbout: "Sanitary products and equipment for professionals.",
    rightsReserved: "All rights reserved.",
    aboutTitle: "About us",
    aboutIntro: "Servitech Xpert is a young, rapidly expanding company founded in 2007 by Daniel Valiquette, who has over 20 years of experience in the field. Servitech Xpert distributes a complete range of sanitary products and equipment to its customers, as well as providing exceptional repair services. We are able to offer you a turnkey solution tailored to your needs.",
    aboutPartnersTitle: "Partnership with our suppliers",
    aboutPartnersText: "You can count on Servitech Xpert to find the best suppliers in their category — suppliers who have built their reputation by developing effective and reliable products. These suppliers help us offer solutions to optimize the efficiency of your operations.",
    aboutBrandsTitle: "Our brands",
    contactHeroTitle: "Contact us",
    contactInfoTitle: "Contact information",
    contactFormTitle: "Contact form",
    contactFormIntro: "To get in touch with us or for any other information requests, write to us here. We will respond as soon as possible.",
    ciAddress: "Address",
    ciEmail: "Email",
    ciPhone: "Phone",
    ciTollFree: "Toll-free",
    ciFax: "Fax",
    fldName: "Full name",
    fldSubject: "Subject",
    fldMessage: "Message",
    fldSend: "Send",
    contactSent: "Thank you! Your message has been sent. We'll get back to you soon.",
    contactErr: "Failed to send. Please try again.",
    newProducts: "New products",
    featuredProducts: "Featured products",
    brands: "Brands",
    brandsManagerHint: "Manage the brand logos shown at the bottom of the site (home & About). The name is only used to identify them here.",
    addBrand: "Add a brand",
    noBrands: "No brand yet. Click 'Add a brand'.",
    brandName: "Brand name (identification)",
    addLogo: "Add logo",
    replaceLogo: "Replace logo",
    logoUpdated: "Logo updated",
    uploadFailed: "Upload failed",
    saveFailed: "Save failed",
    visible: "Visible",
    hidden: "Hidden",
    viewCategoryProducts: "View products in this category",
    openProductPage: "Open product page (new tab)",
    filteredByCategory: "Filtered by category",
    clearFilter: "Clear filter",
    shopNow: "Shop now",
    heroTitle: "Sanitary products & equipment",
    heroText: "Place your orders online — a representative will confirm pricing.",
    myCart: "My cart",
    cartEmpty: "Cart is empty",
    items: "items",
    aboutCompany: "About our company",
    blog: "Blog",
    paperSystemTitle: "Paper Products Systems",
    handSystemTitle: "Hand Care Systems",
    viewCategory: "View the category",
    blogHeroTitle: "Latest news",
    blogEmpty: "No articles yet. Check back soon!",
    blogReadMore: "Read more",
    blogBackToList: "Back to news",
    blogPublishedOn: "Published on",
    addArticle: "Add article",
    newArticle: "New article",
    editArticle: "Edit article",
    deleteArticle: "Delete",
    confirmDeleteArticle: "Delete this article?",
    noArticles: "No articles yet. Click \"Add article\" to get started.",
    articleTitleFr: "Title (FR)",
    articleTitleEn: "Title (EN)",
    articleExcerptFr: "Excerpt (FR)",
    articleExcerptEn: "Excerpt (EN)",
    articleBodyFr: "Content (FR)",
    articleBodyEn: "Content (EN)",
    articleCover: "Cover image",
    articleSlug: "URL slug",
    articleStatus: "Status",
    statusDraft: "Draft",
    statusPublished: "Published",
    loginTitle: "Internal Portal",
    loginSubtitle: "Customer sales and consumption tracking",
    email: "Email",
    email2: "Email 2",
    noteInterne: "Internal note",
    noteClient: "Client note",
    noteInterneHint: "Internal use — never visible to the client",
    noteClientHint: "Visible to the client (printed on the invoice)",
    poNumber: "Purchase order",
    poNumberHint: "Purchase order no. (optional)",
    withSimilar: "Add with similar products from the website",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    loginError: "Invalid email or password",
    confidential: "Strictly confidential — internal use only",
    dashboard: "Dashboard",
    customers: "Customers",
    totalCustomers: "Active customers",
    totalSalesYtd: "Total sales (year to date)",
    growingCustomers: "Growing customers",
    decliningCustomers: "Declining customers",
    topCustomers: "Top customers",
    searchCustomers: "Search a customer, account #, COOP code, contact...",
    // Sync
    dataSource: "Data source",
    demoData: "Demo data",
    liveData: "CS-Cart live",
    syncNow: "Sync CS-Cart",
    syncing: "Syncing...",
    lastSync: "Last sync",
    neverSynced: "Never synced",
    syncStarted: "Sync started...",
    syncDone: "CS-Cart data synced",
    syncFailed: "Sync failed",
    businessName: "Business name",
    accountNumber: "Account #",
    contact: "Contact",
    coopClientCode: "COOP Client Code",
    phone: "Phone",
    salesYtd: "Sales (year)",
    trend: "Trend",
    products: "Products",
    viewProfile: "View profile",
    customerProfile: "Customer profile",
    address: "Address",
    fax: "Fax",
    faxNotAvailable: "Not available",
    generalContact: "General contact",
    currentMonthSales: "Current month sales",
    ytdSales: "Sales (year to date)",
    samePeriodLastYear: "Same period last year",
    monthlyConsumption: "Monthly consumption (last 12 months)",
    salesComparison: "Sales comparison",
    noSalesRecorded: "No sales recorded for this client (no orders)",
    productDetails: "Product details",
    productCode: "Product code",
    description: "Description",
    lastPaidPrice: "Last paid price",
    lastPaidDate: "Date",
    qtyThisYear: "Qty current year",
    qtyLastYear: "Qty previous year",
    currentYear: "Current year",
    previousYear: "Previous year",
    generateReport: "Generate report",
    annualReport: "Annual report",
    monthlyBreakdown: "Monthly breakdown",
    month: "Month",
    total: "Total",
    year: "Year",
    print: "Print",
    backOffice: "Back Office",
    ordersManagement: "Order management",
    searchOrders: "Search",
    searchOrdersHint: "Invoice no., customer or COOP code",
    dateFrom: "From",
    dateTo: "To",
    allStatuses: "All statuses",
    clearFilters: "Clear",
    resultSingular: "order",
    resultPlural: "orders",
    noOrdersMatch: "No order matches the filters",
    orders: "Orders",
    orderFrom: "Customer",
    placedOn: "Date",
    orderDetail: "Order detail",
    orderItems: "Items",
    status: "Status",
    statusNew: "New",
    statusPriced: "Priced",
    statusInvoiced: "Invoiced",
    statusSent: "Sent",
    unitPrice: "Unit price",
    quantity: "Qty",
    grandTotal: "Total",
    subtotal: "Subtotal",
    gstShort: "GST (5%)",
    qstShort: "QST (9.975%)",
    savePricing: "Save prices",
    generateInvoice: "Generate invoice",
    editInvoice: "Edit invoice",
    deleteInvoice: "Delete",
    confirmDeleteInvoice: "Delete this invoice / order? This cannot be undone.",
    invoiceFrozen: "Invoice locked (paid or sent to COOP)",
    deleted: "Deleted",
    downloadPdf: "Download PDF",
    sendInvoice: "Send by email",
    invoiceSent: "Invoice sent",
    invoiceCreated: "Invoice generated",
    invoiceNumber: "Invoice #",
    priceUpdated: "Prices saved",
    saveFailed: "Save failed",
    pending: "Pending",
    productsManagement: "Product management",
    editProduct: "Edit product",
    save: "Save",
    saved: "Saved",
    nameFr: "Name (FR)",
    nameEn: "Name (EN)",
    descriptionFr: "Description (FR)",
    descriptionEn: "Description (EN)",
    taxGst: "GST taxable",
    taxQst: "QST taxable",
    statusActive: "Active",
    statusDisabled: "Disabled",
    clientPortal: "Client portal",
    myOrders: "My orders",
    viewInvoice: "View invoice",
    backToSite: "Back to site",
    welcome: "Welcome",
    createClientAccount: "Create client account",
    createAccount: "Create account",
    clientRegisterInfo: "Use the email linked to your Servitech Xpert client account.",
    registerError: "Unable to create the account",
    price: "Price",
    category: "Category",
    actions: "Actions",
    edit: "Edit",
    pdf: "PDF",
    name: "Name",
    images: "Images",
    imageUrl: "Image URL",
    addPdf: "Add a PDF",
    statusHidden: "Hidden",
    productUpdated: "Product updated successfully",
    deleteProduct: "Delete product",
    deleteProductTitle: "Permanently delete this product?",
    deleteProductWarning: "This action is irreversible. The product and its variants will be permanently removed from the database.",
    deletePermanently: "Delete permanently",
    productDeleted: "Product deleted",
    customerDeleted: "Customer deleted",
    deleteCustomerTitle: "Delete this customer?",
    deleteCustomerWarning: "This action is permanent. The customer record and its login account will be deleted. Order/invoice history is kept. Other branches are not affected.",
    deleteFailed: "Delete failed",
    newVariation: "New variation",
    addVariationBtn: "Add variation",
    attachExisting: "Or attach an existing product",
    newVariationHint: "Creates a new variation of this product (name, image and category inherited from the parent, editable in the row).",
    variantCreated: "Variation created",
    pdfUploadedClickSave: "PDF uploaded — click \"Save\" to add it to the product",
    pdfNameFr: "Display name (FR)",
    pdfNameEn: "Display name (EN)",
    variationDeleted: "Variation deleted",
    deleteVariationTitle: "Delete this variation?",
    deleteVariationWarning: "This variation will be permanently deleted. The product's other variations are not affected.",
    deleteCategory: "Delete category",
    deleteCategoryTitle: "Permanently delete this category?",
    deleteCategoryWarning: "The category will be deleted. Products are NOT deleted, they only lose this classification.",
    subcategoriesAlsoDeleted: "subcategory(ies) will also be deleted",
    categoryDeleted: "Category deleted",
    saveAndClose: "Save & Close",
    cancel: "Cancel",
    stock: "Inventory",
    customerInformation: "Customer information",
    billingAddress: "Billing address",
    shippingSameAsBilling: "Shipping address same as billing",
    savedShipAddresses: "Saved shipping addresses",
    savedShipAddressesHint: "Add multiple named shipping addresses. They will be offered in a dropdown when creating an order.",
    addShipAddress: "Add an address",
    noShipAddresses: "No saved shipping address.",
    shipAddressName: "Address name",
    shipAddressNamePlaceholder: "e.g. Main warehouse, Laval store",
    chooseShipAddress: "Choose shipping address",
    useBillingAddress: "Billing address",
    otherManualAddress: "Other — enter manually",
    remove: "Remove",
    orderSummary: "Order summary",
    inStock: "in stock",
    categories: "Categories",
    manageCategories: "Categories management",
    position: "Pos.",
    activeCategories: "Active categories",
    hiddenCategories: "Hidden categories",
    disabledCategories: "Disabled categories",
    totalProducts: "Products",
    addCategory: "Add category",
    addSubcategory: "Subcategory",
    categorySaved: "Category saved",
    noCategories: "No categories",
    newCategoryName: "New category name",
    catalogTotals: "Total",
    chooseFormat: "Format",
    newProduct: "New product",
    createProduct: "Create product",
    entreprise: "Enterprise",
    succursale: "Branch",
    selectSuccursale: "Select branch",
    myBranches: "My branches",
    branch: "Branch",
    newOrder: "New order",
    createOrder: "Create order",
    orderCreated: "Order created",
    searchClient: "Search a client...",
    searchProduct: "Search a product...",
    addProduct: "Add a product",
    client: "Client",
    noItems: "No products",
    sendCoop: "Send COOP",
    coopSent: "Sent to COOP",
    coopAlreadySent: "Already sent to the COOP on",
    shippingAddress: "Shipping address",
    shipCity: "City",
    shipProvince: "Province",
    shipPostal: "Postal code",
    coopCategory: "COOP category",
    statusCoopSent: "COOP sent",
    statusOpen: "Open",
    statusPaid: "Paid",
    statusComplete: "Complete",
    statusCancel: "Cancelled",
    duplicate: "Duplicate",
    newCustomer: "New customer",
    createCustomer: "Create customer",
    firstName: "First name",
    lastName: "Last name",
    country: "Country",
    changeClient: "Change client",
    createClientPrompt: "Client not found? Create a new client",
    send: "Send",
    importAddresses: "Import addresses",
    of: "of",
    perPage: "per page",
    note: "Note",
    clients: "Clients",
    viewReport: "View report",
    editCustomer: "Edit customer",
    changePassword: "Portal password",
    newPassword: "New password",
    setPassword: "Set password",
    passwordUpdated: "Password updated",
    portalAccount: "Portal account",
    hasAccount: "Active",
    noPortalAccount: "No account",
    passwordHint: "Min. 6 characters. The client will log in with their email.",
    team: "Team",
    teamMembers: "Team members",
    myProfile: "My profile",
    addMember: "Add member",
    newMember: "New member",
    role: "Role",
    roleAdmin: "Administrator",
    roleSalesRep: "Sales rep",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    resetPassword: "Reset password",
    currentPassword: "Current password",
    initialPassword: "Initial password",
    deleteMember: "Delete",
    confirmDeleteMember: "Delete this member? This cannot be undone.",
    memberAdded: "Member added",
    memberUpdated: "Member updated",
    memberDeleted: "Member deleted",
    profileUpdated: "Profile updated",
    updatePassword: "Change password",
    salesRepLimits: "Access: Dashboard, Clients, Orders. No Products, Categories, Website or Team.",
    you: "You",
    profileInfo: "Profile information",
    changeImage: "Change image",
    requireSignature: "Require client signature",
    requireSignatureHint: "The order stays \"awaiting signature\" until the client signs.",
    clientSignature: "Client signature",
    signerName: "Signer name",
    signHere: "Sign below",
    clear: "Clear",
    later: "Later",
    saveSignature: "Save signature",
    signatureSaved: "Signature saved",
    awaitingSignature: "Awaiting signature",
    collectSignature: "Collect signature",
    signedBy: "Signed by",
    reSign: "Sign again",
    editingLanguage: "Editing language",
    searchCategory: "Search a category...",
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    monthsFull: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  },
};

